var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logText",domProps:{"innerHTML":_vm._s(_vm.line[_vm.item.value])}})
}
var staticRenderFns = []

export { render, staticRenderFns }